export default {
  APP: "APP",
  OPTIONS: "OPTIONS",
  TAXES: "TAXES",
  ORDER_ITEM_TAX_GROUPS: "ORDER_ITEM_TAX_GROUPS",
  CUSTOMERS: "CUSTOMERS",
  SUPPLIERS: "SUPPLIERS",
  CONTACTS: "CONTACTS",
  PRODUCTS: "PRODUCTS",
  FILES: "FILES",
  FOLDERS: "FOLDERS",
  LOCATIONS: "LOCATIONS",
  ORGANIZATIONS: "ORGANIZATIONS",
  SUBSCRIPTIONS: "SUBSCRIPTIONS",
  PACKAGES: "PACKAGES",
  RESELLERS: "RESELLERS",
  USERS: "USERS",
  ROLES: "ROLES",
  PERMISSIONS: "PERMISSIONS",
  LOGS: "LOGS",
  PURCHASES_ORDERS: "PURCHASES_ORDERS",
  PURCHASES_INVOICES: "PURCHASES_INVOICES",
  PURCHASES_DELIVERIES: "PURCHASES_DELIVERIES",
  PURCHASES_PAYMENTS: "PURCHASES_PAYMENTS",
  SALES_ORDERS: "SALES_ORDERS",
  SALES_INVOICES: "SALES_INVOICES",
  SALES_DELIVERIES: "SALES_DELIVERIES",
  SALES_PAYMENTS: "SALES_PAYMENTS",
  RESELLER_INVOICES: "RESELLER_INVOICES",
  RESELLER_PAYMENTS: "RESELLER_PAYMENTS",
  RESELLER_PRODUCTS: "RESELLER_PRODUCTS",
  RESELLER_SERVICES: "RESELLER_SERVICES",
  SERVICECENTERS: "SERVICECENTERS",
  ESTABLISHMENTS: "ESTABLISHMENTS",
  CAFETERIAS: "CAFETERIAS",
  WAREHOUSES: "WAREHOUSES",
  STOCK_MOVEMENTS: "STOCK_MOVEMENTS",
  IMPORTS: "IMPORTS",
  SUPPLY_RULES: "SUPPLY_RULES",
  CATEGORIES: "CATEGORIES",
  PAYMENT_TERMS: "PAYMENT_TERMS",
  EVENTS: "EVENTS",
  CASH_REGISTERS: "CASH_REGISTERS",
  CASH_REGISTER_READINGS: "CASH_REGISTER_READINGS",
  CASH_REGISTER_READING_ITEMS: "CASH_REGISTER_READING_ITEMS",
  REPORTS: "REPORTS",
  EQUIPMENTS: "EQUIPMENTS",
  CATEGORY_EQUIPMENTS: "CATEGORY_EQUIPMENTS",
  EQUIPMENT_TRANSFERS: "EQUIPMENT_TRANSFERS",
  WEEKLY_REPORTS: "WEEKLY_REPORTS",
  ESTABLISHMENT_TRANSFER: "ESTABLISHMENT_TRANSFER",
  ESTABLISHMENT_INTERNAL_INVOICES: "ESTABLISHMENT_INTERNAL_INVOICES",
  ESTABLISHMENT_INTERNAL_ORDERS: "ESTABLISHMENT_INTERNAL_ORDERS",
  TRAININGS: "TRAININGS",
};
